export const getDefaultFolderToLoad = () => 'inbox';
